
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateCalculationitemsGroupSortableRankDtoFormGroup() {
return new FormGroup({
    id: new FormControl<number | undefined>(undefined, [Validators.required]),
    sortableRank: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      